import { useCallback, useState } from "react";
import { useSnackbar } from "$utils/useSnackbar";
import { ShippingFileService } from "$services";
import {
  MESSAGE_DELETE_FAILED,
  MESSAGE_DELETE_OK,
  snackbarErrorOptions,
  snackbarSuccessOptions,
} from "$utils/SnackbarOptions";
import useAuth from "./useAuth";

const useShippingFile = (shippingRecordId: string) => {
  const { token } = useAuth();

  // Create
  const uploadShippingFile = useCallback(
    async (data: any) => {
      await ShippingFileService.createShippingFile(
        token,
        shippingRecordId,
        data
      );
    },
    [shippingRecordId, token]
  );

  // Delete
  const [deleteSnack, setDeleteSnack] = useState(true);
  const [openSnackbar] = useSnackbar(
    deleteSnack ? snackbarSuccessOptions : snackbarErrorOptions
  );
  const deleteShippingFile = useCallback(
    async (fileId: string) => {
      try {
        await ShippingFileService.deleteShippingFile(
          token,
          shippingRecordId,
          fileId
        );
        setDeleteSnack(true);
        openSnackbar(MESSAGE_DELETE_OK);
      } catch (error: any) {
        setDeleteSnack(false);
        openSnackbar(MESSAGE_DELETE_FAILED, error.message);
      }
    },
    [openSnackbar, shippingRecordId, token]
  );

  return {
    uploadShippingFile,
    deleteShippingFile,
  };
};

export default useShippingFile;
